import axios from "axios";
import base_Url from "../BaseUrl";

const Axios = axios.create({
  baseURL: base_Url,
});

export default Axios;
